<template>
  <div
    id="app"
    style="
      position: relative;
      margin: 0 auto;
      max-width: unset;
      width: calc(100 * var(--app-vw));
    "
  >
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    this.setAppWidthAsCSSVar();
  },
  created() {
    document.title = "第十二届上海市慈善之星选树活动入围对象优秀事迹展示";
  },
  methods: {
    setAppWidthAsCSSVar() {
      let appElement = document.getElementById("app");
      if (appElement) {
        let width =
          innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        let height =
          innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
        console.log(width / height);

        // 设置屏幕比例，保存至storage中，
        // short < 16/9
        // normal >= 16/9
        // long >= 18/9
        if (height / width <= 16 / 9) {
          localStorage.setItem("ScreenRatio", "short");
        } else if (height / width <= 18 / 9) {
          localStorage.setItem("ScreenRatio", "normal");
        } else {
          localStorage.setItem("ScreenRatio", "long");
        }

        if (width / height > 0.75) {
          appElement.style["width"] = "56.25vh";
          appElement.style["max-width"] = "56.25vh";
        } else {
          appElement.style["width"] = "unset";
          appElement.style["max-width"] = "unset";
        }
        let appWidth = appElement.clientWidth / 100; // 获取 #app 的宽度
        document.documentElement.style.setProperty("--app-vw", appWidth + "px");
      }
    },
  },
};
</script>

<style>
body {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100% !important;
}

* {
  margin: 0px;
  padding: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: calc(4 * var(--app-vw));
  line-height: 1.25em;
  font-weight: normal;
}

img {
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}

@font-face {
  font-family: "lsjgyzyt";
  src: url("./assets/font/SourceHanSansSC-Regular-2.otf");
  font-weight: normal;
  font-style: normal;
}

.font {
  font-family: "lsjgyzyt";
  align-items: baseline;
  text-align: justify;
}

.nowrap {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
}

.bold {
  font-weight: bold;
}

.primary {
  color: #ea1900;
}

.bgImg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  image-rendering: -webkit-optimize-contrast;
  position: absolute;
  padding: 0px;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
}

.sgl-flex {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: center !important;
}

.sgl-center {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
}

.sgl-aligncenter {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
}

.sgl-justifycenter {
  display: flex !important;
  flex-direction: column;
  justify-content: center !important;
}

.sgl-line-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sgl-line-2 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical !important;
}
.sgl-line-3 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical !important;
}
.sgl-line-4 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical !important;
}
.sgl-line-5 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical !important;
}

@keyframes playframes {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}

.scaleinsmallbig {
  -webkit-transform: scale(0) translate3d(0, 0, 0);
  transform: scale(0) translate3d(0, 0, 0);
  opacity: 1;
  animation: scale-in-center, smallbig alternate;
  animation-duration: 0.5s, 1.5s;
  animation-timing-function: linear, linear;
  animation-iteration-count: 1, infinite;
  animation-delay: 0s, 0.5s;
}

.sleepsmallbig {
  -webkit-transform: scale(0) translate3d(0, 0, 0);
  transform: scale(0) translate3d(0, 0, 0);
  opacity: 1;
  animation: smallbig 1.5s linear infinite 0.5s;
}

.scalein {
  -webkit-transform: scale(0) translate3d(0, 0, 0);
  transform: scale(0) translate3d(0, 0, 0);
  opacity: 1;
  animation: scale-in-center;
  animation-duration: 0.5s;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

@keyframes smallbig {
  0%,
  100% {
    transform: scale(1) translate3d(0, 0, 0);
  }
  50% {
    transform: scale(1.1) translate3d(0, 0, 0);
  }
}

@-webkit-keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0) translate3d(0, 0, 0);
    transform: scale(0) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1) translate3d(0, 0, 0);
    transform: scale(1) translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0) translate3d(0, 0, 0);
    transform: scale(0) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1) translate3d(0, 0, 0);
    transform: scale(1) translate3d(0, 0, 0);
    opacity: 1;
  }
}

@-webkit-keyframes opacityinframes {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes opacityinframes {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.opacityin {
  -webkit-transform: opacity(0) translate3d(0, 0, 0);
  transform: opacity(0) translate3d(0, 0, 0);
  animation: opacityinframes;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

.hiddenscroll::-webkit-scrollbar {
  display: none;
}

@keyframes nameRoll-14 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-4 * var(--app-vw));
  }
}
@keyframes nameRoll-15 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-8 * var(--app-vw));
  }
}
@keyframes nameRoll-16 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-12 * var(--app-vw));
  }
}
@keyframes nameRoll-17 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-16 * var(--app-vw));
  }
}
@keyframes nameRoll-18 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-20 * var(--app-vw));
  }
}
@keyframes nameRoll-19 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-24 * var(--app-vw));
  }
}
@keyframes nameRoll-20 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-28 * var(--app-vw));
  }
}
@keyframes nameRoll-21 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-32 * var(--app-vw));
  }
}
@keyframes nameRoll-22 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-36 * var(--app-vw));
  }
}
@keyframes nameRoll-23 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-40 * var(--app-vw));
  }
}
@keyframes nameRoll-24 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-44 * var(--app-vw));
  }
}
@keyframes nameRoll-25 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-48 * var(--app-vw));
  }
}
@keyframes nameRoll-26 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-52 * var(--app-vw));
  }
}
@keyframes nameRoll-27 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-56 * var(--app-vw));
  }
}
@keyframes nameRoll-28 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-60 * var(--app-vw));
  }
}
@keyframes nameRoll-29 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-64 * var(--app-vw));
  }
}
@keyframes nameRoll-30 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-68 * var(--app-vw));
  }
}
@keyframes nameRoll-31 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-72 * var(--app-vw));
  }
}
@keyframes nameRoll-32 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-76 * var(--app-vw));
  }
}
@keyframes nameRoll-33 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-80 * var(--app-vw));
  }
}
@keyframes nameRoll-34 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-84 * var(--app-vw));
  }
}
@keyframes nameRoll-35 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-88 * var(--app-vw));
  }
}
@keyframes nameRoll-36 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-92 * var(--app-vw));
  }
}
@keyframes nameRoll-37 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-96 * var(--app-vw));
  }
}
@keyframes nameRoll-38 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-100 * var(--app-vw));
  }
}
@keyframes nameRoll-39 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-104 * var(--app-vw));
  }
}
@keyframes nameRoll-40 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-108 * var(--app-vw));
  }
}
@keyframes nameRoll-41 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-112 * var(--app-vw));
  }
}
@keyframes nameRoll-42 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-116 * var(--app-vw));
  }
}
@keyframes nameRoll-43 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-120 * var(--app-vw));
  }
}
@keyframes nameRoll-44 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-124 * var(--app-vw));
  }
}
@keyframes nameRoll-45 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-128 * var(--app-vw));
  }
}
@keyframes nameRoll-46 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-132 * var(--app-vw));
  }
}
@keyframes nameRoll-47 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-136 * var(--app-vw));
  }
}
@keyframes nameRoll-48 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-140 * var(--app-vw));
  }
}
@keyframes nameRoll-49 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-144 * var(--app-vw));
  }
}
@keyframes nameRoll-50 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-148 * var(--app-vw));
  }
}
@keyframes nameRoll-51 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-152 * var(--app-vw));
  }
}
@keyframes nameRoll-52 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-156 * var(--app-vw));
  }
}
@keyframes nameRoll-53 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-160 * var(--app-vw));
  }
}
@keyframes nameRoll-54 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-164 * var(--app-vw));
  }
}
@keyframes nameRoll-55 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-168 * var(--app-vw));
  }
}
@keyframes nameRoll-56 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-172 * var(--app-vw));
  }
}
@keyframes nameRoll-57 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-176 * var(--app-vw));
  }
}
@keyframes nameRoll-58 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-180 * var(--app-vw));
  }
}
@keyframes nameRoll-59 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-184 * var(--app-vw));
  }
}
@keyframes nameRoll-60 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-188 * var(--app-vw));
  }
}
@keyframes nameRoll-61 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-192 * var(--app-vw));
  }
}
@keyframes nameRoll-62 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-196 * var(--app-vw));
  }
}
@keyframes nameRoll-63 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-200 * var(--app-vw));
  }
}
@keyframes nameRoll-64 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-204 * var(--app-vw));
  }
}
@keyframes nameRoll-65 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-208 * var(--app-vw));
  }
}
@keyframes nameRoll-66 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-212 * var(--app-vw));
  }
}
@keyframes nameRoll-67 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-216 * var(--app-vw));
  }
}
@keyframes nameRoll-68 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-220 * var(--app-vw));
  }
}
@keyframes nameRoll-69 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-224 * var(--app-vw));
  }
}
@keyframes nameRoll-70 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-228 * var(--app-vw));
  }
}
@keyframes nameRoll-71 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-232 * var(--app-vw));
  }
}
@keyframes nameRoll-72 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-236 * var(--app-vw));
  }
}
@keyframes nameRoll-73 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-240 * var(--app-vw));
  }
}
@keyframes nameRoll-74 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-244 * var(--app-vw));
  }
}
@keyframes nameRoll-75 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-248 * var(--app-vw));
  }
}
@keyframes nameRoll-76 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-252 * var(--app-vw));
  }
}
@keyframes nameRoll-77 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-256 * var(--app-vw));
  }
}
@keyframes nameRoll-78 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-260 * var(--app-vw));
  }
}
@keyframes nameRoll-79 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-264 * var(--app-vw));
  }
}
@keyframes nameRoll-80 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-268 * var(--app-vw));
  }
}
@keyframes nameRoll-81 {
  0% {
    left: 0;
  }
  100% {
    left: calc(-272 * var(--app-vw));
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue